module.exports = __webpack_public_path__ + "static/media/next-page-icon.221f9e17.svg";